export default {"src":"/_next/static/media/ic-time.ed5fcd0a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};